import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';

const STADIUM_IMG = 'https://images.pexels.com/photos/32471031/pexels-photo-32471031.jpeg';

// Two-column auth shell: form on the left (obsidian), sports image on the right.
export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen flex bg-[#0A0A0A] text-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
      <div className="w-full lg:w-1/2 flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-12">
        <div className="max-w-md w-full mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 mb-10" data-testid="sports-brand-home-link">
            <span className="h-9 w-9 rounded-md bg-[#E63946] flex items-center justify-center shadow-[0_0_18px_rgba(230,57,70,0.5)]">
              <Activity className="h-5 w-5 text-white" strokeWidth={2.4} />
            </span>
            <span className="text-lg font-bold tracking-tight" style={{ fontFamily: 'Oswald, sans-serif' }}>
              AGRIBOOKS <span className="text-[#E63946]">SPORTS</span>
            </span>
          </Link>

          <h1 className="text-4xl tracking-tight uppercase" style={{ fontFamily: 'Oswald, sans-serif', fontWeight: 700 }}>
            {title}
          </h1>
          {subtitle && <p className="mt-2 text-sm text-[#A3A3A3]">{subtitle}</p>}

          <div className="mt-8">{children}</div>

          {footer && <div className="mt-8 text-sm text-[#A3A3A3]">{footer}</div>}
        </div>
      </div>

      <div className="hidden lg:block lg:w-1/2 relative">
        <img src={STADIUM_IMG} alt="Stadium floodlights" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-black via-black/70 to-[#E63946]/30" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="text-3xl leading-tight uppercase" style={{ fontFamily: 'Oswald, sans-serif', fontWeight: 700 }}>
            Run your courts.<br />Fill every slot.
          </p>
          <p className="mt-3 text-sm text-white/70 max-w-sm">
            Bookings, availability and your own customer site — built for sports facilities.
          </p>
        </div>
      </div>
    </div>
  );
}

export function SportsInput({ label, testid, ...props }) {
  return (
    <label className="block mb-4">
      <span className="block text-xs uppercase tracking-wide text-[#A3A3A3] mb-1.5">{label}</span>
      <input
        data-testid={testid}
        className="w-full bg-[#0A0A0A] border border-[#262626] text-white rounded-md px-4 py-2.5 outline-none focus:border-[#E63946] focus:ring-1 focus:ring-[#E63946] transition-colors"
        {...props}
      />
    </label>
  );
}

export function SportsButton({ children, testid, ...props }) {
  return (
    <button
      data-testid={testid}
      className="w-full bg-[#E63946] hover:bg-[#D62828] disabled:opacity-50 text-white font-bold uppercase tracking-wider rounded-md py-3 transition-colors"
      {...props}
    >
      {children}
    </button>
  );
}
